// imageBasedReceiptUtils.js - Versão Melhorada com Design Apple

/**
 * Função para imprimir comprovante baseado em imagem com design Apple-style
 * @param {Object} order - Objeto contendo os dados do pedido
 */
export const printImageBasedReceipt = (order) => {
  try {
    console.log('Iniciando impressão do comprovante para pedido:', order.id);
    
    // Gerar o conteúdo HTML do comprovante
    const receiptContent = generateReceiptHTML(order);
    
    // Obter dimensões da tela para janela maximizada
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    
    // Abrir janela maximizada ocupando toda a tela
    const printWindow = window.open(
      '',
      'PrintReceipt',
      `width=${screenWidth},height=${screenHeight},left=0,top=0,scrollbars=yes,resizable=yes,status=no,menubar=no,toolbar=no,location=no,directories=no`
    );
    
    // Verificar se a janela foi aberta (pode ser bloqueada por pop-up blocker)
    if (!printWindow) {
      alert('Por favor, permita pop-ups para imprimir o comprovante.');
      return;
    }
    
    // Escrever o conteúdo completo na janela
    printWindow.document.write(`
      <!DOCTYPE html>
      <html lang="pt-BR">
        <head>
          <title>Comprovante de Pedido #${order.id}</title>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <style>
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            
            body {
              font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro Display', 'Helvetica Neue', Arial, sans-serif;
              line-height: 1.5;
              color: #1d1d1f;
              background: #f5f5f7;
              padding: 24px;
              min-height: 100vh;
              font-size: 17px;
              -webkit-font-smoothing: antialiased;
              -moz-osx-font-smoothing: grayscale;
            }
            
            .receipt-container {
              max-width: 800px;
              margin: 0 auto;
              background: #ffffff;
              border-radius: 16px;
              overflow: hidden;
              box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.04);
              border: 1px solid #e5e5e7;
            }
            
            .header {
              background: linear-gradient(135deg, #1d1d1f 0%, #424245 100%);
              color: #ffffff;
              text-align: center;
              padding: 48px 32px;
              position: relative;
              overflow: hidden;
            }
            
            .header::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: radial-gradient(circle at 50% 0%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
              pointer-events: none;
            }
            
            .header h1 {
              font-size: 32px;
              font-weight: 700;
              margin-bottom: 8px;
              letter-spacing: -0.02em;
              position: relative;
              z-index: 1;
            }
            
            .header p {
              font-size: 19px;
              font-weight: 400;
              opacity: 0.9;
              position: relative;
              z-index: 1;
            }
            
            .order-number {
              font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
              background: rgba(255, 255, 255, 0.15);
              padding: 6px 12px;
              border-radius: 8px;
              font-weight: 600;
              margin: 0 4px;
              backdrop-filter: blur(10px);
            }
            
            .section {
              padding: 32px;
              border-bottom: 1px solid #f2f2f7;
            }
            
            .section:last-child {
              border-bottom: none;
            }
            
            .section-title {
              font-size: 22px;
              font-weight: 700;
              color: #1d1d1f;
              margin-bottom: 24px;
              letter-spacing: -0.01em;
              display: flex;
              align-items: center;
              gap: 12px;
            }
            
            .section-icon {
              font-size: 24px;
              width: 32px;
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 8px;
              background: #f2f2f7;
            }
            
            .info-grid {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
              gap: 20px;
            }
            
            .info-item {
              background: #fbfbfd;
              border: 1px solid #f2f2f7;
              border-radius: 12px;
              padding: 20px;
              transition: all 0.2s ease;
            }
            
            .info-item:hover {
              border-color: #e5e5e7;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
            }
            
            .info-label {
              font-size: 13px;
              font-weight: 600;
              color: #86868b;
              text-transform: uppercase;
              letter-spacing: 0.06em;
              margin-bottom: 8px;
            }
            
            .info-value {
              font-size: 17px;
              font-weight: 500;
              color: #1d1d1f;
              line-height: 1.4;
            }
            
            .status-badge {
              display: inline-flex;
              align-items: center;
              gap: 8px;
              padding: 12px 20px;
              border-radius: 24px;
              font-weight: 700;
              font-size: 14px;
              text-transform: uppercase;
              letter-spacing: 0.03em;
              width: fit-content;
              margin-top: 4px;
            }
            
            .status-aprovado {
              background: #e8f5e8;
              color: #30a14e;
              border: 2px solid #30a14e;
            }
            
            .status-pendente {
              background: #fff3cd;
              color: #b08800;
              border: 2px solid #b08800;
            }
            
            .status-rejeitado {
              background: #f8d7da;
              color: #d73a49;
              border: 2px solid #d73a49;
            }
            
            .items-table {
              width: 100%;
              border-collapse: separate;
              border-spacing: 0;
              background: #ffffff;
              border-radius: 12px;
              overflow: hidden;
              border: 1px solid #f2f2f7;
              margin-top: 16px;
            }
            
            .items-table th {
              background: #fbfbfd;
              color: #1d1d1f;
              font-weight: 700;
              font-size: 13px;
              text-transform: uppercase;
              letter-spacing: 0.06em;
              padding: 20px 24px;
              text-align: left;
              border-bottom: 1px solid #f2f2f7;
            }
            
            .items-table td {
              padding: 24px;
              border-bottom: 1px solid #f2f2f7;
              vertical-align: top;
            }
            
            .items-table tbody tr {
              transition: background-color 0.15s ease;
            }
            
            .items-table tbody tr:hover {
              background-color: #fbfbfd;
            }
            
            .items-table tbody tr:last-child td {
              border-bottom: none;
            }
            
            .text-center {
              text-align: center;
            }
            
            .text-right {
              text-align: right;
            }
            
            .item-name {
              font-size: 17px;
              font-weight: 600;
              color: #1d1d1f;
              margin-bottom: 4px;
              line-height: 1.3;
            }
            
            .item-description {
              font-size: 15px;
              color: #86868b;
              line-height: 1.4;
            }
            
            .price-container {
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              gap: 2px;
            }
            
            .original-price {
              font-size: 14px;
              color: #86868b;
              text-decoration: line-through;
              font-weight: 400;
              line-height: 1.2;
            }
            
            .current-price {
              font-size: 16px;
              font-weight: 600;
              color: #1d1d1f;
              line-height: 1.2;
            }
            
            .discounted-price {
              font-size: 16px;
              font-weight: 600;
              color: #30a14e;
              line-height: 1.2;
            }
            
            .discount-badge {
              display: inline-flex;
              align-items: center;
              gap: 3px;
              background: #e8f5e8;
              color: #30a14e;
              padding: 2px 8px;
              border-radius: 12px;
              font-size: 11px;
              font-weight: 700;
              margin-top: 2px;
              line-height: 1;
            }
            
            .quantity-badge {
              background: #f2f2f7;
              color: #1d1d1f;
              padding: 8px 16px;
              border-radius: 20px;
              font-weight: 600;
              font-size: 15px;
              display: inline-block;
            }
            
            .savings-row {
              background: linear-gradient(135deg, #e8f5e8 0%, #d4edda 100%);
              font-weight: 600;
              color: #30a14e;
            }
            
            .savings-row td {
              padding: 20px 24px;
              font-style: italic;
            }
            
            .total-row {
              background: linear-gradient(135deg, #1d1d1f 0%, #424245 100%);
              color: #ffffff;
              font-weight: 700;
              font-size: 19px;
            }
            
            .total-row td {
              padding: 24px;
              border: none;
            }
            
            .currency {
              font-variant-numeric: tabular-nums;
            }
            
            .print-buttons {
              text-align: center;
              padding: 32px;
              background: #fbfbfd;
              display: flex;
              justify-content: center;
              gap: 16px;
              flex-wrap: wrap;
            }
            
            .btn {
              background: #1d1d1f;
              color: #ffffff;
              border: none;
              padding: 16px 32px;
              border-radius: 24px;
              cursor: pointer;
              font-size: 17px;
              font-weight: 600;
              display: flex;
              align-items: center;
              gap: 8px;
              min-width: 160px;
              justify-content: center;
              transition: all 0.2s ease;
              font-family: inherit;
              text-decoration: none;
            }
            
            .btn:hover {
              background: #424245;
              transform: translateY(-1px);
              box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
            }
            
            .btn:active {
              transform: translateY(0);
            }
            
            .btn-secondary {
              background: #86868b;
            }
            
            .btn-secondary:hover {
              background: #6e6e73;
            }
            
            .footer {
              background: #fbfbfd;
              text-align: center;
              padding: 32px;
              color: #86868b;
              font-size: 15px;
              line-height: 1.6;
              border-top: 1px solid #f2f2f7;
            }
            
            .footer-title {
              font-weight: 600;
              color: #1d1d1f;
              margin-bottom: 8px;
            }
            
            .empty-state {
              text-align: center;
              padding: 48px 24px;
              color: #86868b;
            }
            
            .empty-state-icon {
              font-size: 48px;
              margin-bottom: 16px;
              opacity: 0.6;
            }
            
            /* Estilos para impressão */
            @media print {
              body {
                background: white;
                padding: 0;
                font-size: 14px;
              }
              
              .receipt-container {
                box-shadow: none;
                border: none;
                border-radius: 0;
                max-width: none;
              }
              
              .print-buttons {
                display: none;
              }
              
              .header {
                background: #1d1d1f !important;
                color: white !important;
                padding: 32px;
              }
              
              .section {
                padding: 24px;
              }
              
              .items-table th,
              .items-table td {
                padding: 16px;
              }
              
              .total-row {
                background: #1d1d1f !important;
                color: white !important;
              }
              
              .savings-row {
                background: #f0f0f0 !important;
                color: #30a14e !important;
              }
              
              .status-badge {
                border: 1px solid currentColor !important;
              }
              
              .discount-badge {
                border: 1px solid #30a14e !important;
                background: #e8f5e8 !important;
                color: #30a14e !important;
              }
              
              .discounted-price {
                color: #30a14e !important;
              }
              
              .original-price {
                color: #86868b !important;
                text-decoration: line-through !important;
              }
            }
            
            @page {
              margin: 1.5cm;
              size: A4;
            }
            
            /* Responsividade */
            @media (max-width: 768px) {
              body {
                padding: 16px;
                font-size: 16px;
              }
              
              .receipt-container {
                border-radius: 12px;
              }
              
              .header {
                padding: 32px 24px;
              }
              
              .header h1 {
                font-size: 28px;
              }
              
              .section {
                padding: 24px 20px;
              }
              
              .info-grid {
                grid-template-columns: 1fr;
                gap: 16px;
              }
              
              .items-table th,
              .items-table td {
                padding: 16px 12px;
                font-size: 15px;
              }
              
              .original-price {
                font-size: 13px;
              }
              
              .current-price,
              .discounted-price {
                font-size: 15px;
              }
              
              .discount-badge {
                font-size: 10px;
                padding: 2px 6px;
              }
              
              .section-title {
                font-size: 20px;
              }
              
              .print-buttons {
                padding: 24px 20px;
                flex-direction: column;
                align-items: center;
              }
              
              .btn {
                width: 100%;
                max-width: 280px;
              }
            }
          </style>
        </head>
        <body>
          <div class="receipt-container">
            ${receiptContent}
            
            <div class="print-buttons">
              <button class="btn" onclick="window.print()" title="Imprimir comprovante">
                🖨️ Imprimir Comprovante
              </button>
              <button class="btn btn-secondary" onclick="window.close()" title="Fechar janela">
                ✕ Fechar Janela
              </button>
            </div>
          </div>
          
          <script>
            // Maximizar a janela após carregar
            try {
              window.moveTo(0, 0);
              window.resizeTo(window.screen.width, window.screen.height);
            } catch(e) {
              console.log('Não foi possível redimensionar automaticamente');
            }
            
            // Focar na janela
            window.focus();
            
            // Garantir maximização após carregamento completo
            window.onload = function() {
              try {
                window.moveTo(0, 0);
                window.resizeTo(window.screen.availWidth, window.screen.availHeight);
                window.focus();
              } catch(e) {
                console.log('Redimensionamento automático não suportado pelo navegador');
              }
            };
            
            // Atalhos de teclado
            document.addEventListener('keydown', function(e) {
              // Ctrl+P para imprimir
              if (e.ctrlKey && e.key === 'p') {
                e.preventDefault();
                window.print();
              }
              // ESC para fechar
              if (e.key === 'Escape') {
                window.close();
              }
            });
          </script>
        </body>
      </html>
    `);
    
    printWindow.document.close();
    printWindow.focus();
    
    // Tentar maximizar novamente após um pequeno delay
    setTimeout(() => {
      try {
        printWindow.moveTo(0, 0);
        printWindow.resizeTo(window.screen.width, window.screen.height);
        printWindow.focus();
      } catch(e) {
        console.log('Segunda tentativa de maximização falhou');
      }
    }, 200);
    
    console.log('Janela de impressão aberta com sucesso');
    
  } catch (error) {
    console.error('Erro ao abrir janela de impressão:', error);
    alert('Erro ao gerar comprovante para impressão. Tente novamente.');
    throw error;
  }
};

/**
 * Função auxiliar para gerar o HTML do comprovante com design Apple-style
 * @param {Object} order - Objeto contendo os dados do pedido
 * @returns {string} HTML formatado do comprovante
 */
const generateReceiptHTML = (order) => {
  // Funções auxiliares para formatação
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value || 0);
  };

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }) + ' às ' + date.toLocaleTimeString('pt-BR', { 
        hour: '2-digit', 
        minute: '2-digit' 
      });
    } catch (error) {
      return 'Data inválida';
    }
  };

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case 'aprovado':
        return 'status-aprovado';
      case 'pendente':
        return 'status-pendente';
      case 'rejeitado':
        return 'status-rejeitado';
      default:
        return 'status-pendente';
    }
  };

  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case 'aprovado':
        return '✓';
      case 'pendente':
        return '⏳';
      case 'rejeitado':
        return '✕';
      default:
        return '📋';
    }
  };

  // Calcular estatísticas do pedido
  const calculateOrderStats = () => {
    if (!order.items || order.items.length === 0) {
      return {
        totalItems: 0,
        totalSavings: 0,
        itemsWithDiscount: 0,
        hasDiscounts: false
      };
    }

    const stats = order.items.reduce((acc, item) => {
      const quantity = item.quantity || 0;
      const hasDiscount = item.hasDiscount || (item.discountAmount && item.discountAmount > 0) || (item.originalPrice && item.originalPrice > item.price);
      const originalPrice = item.originalPrice || item.price;
      const currentPrice = item.price;
      const discountAmount = item.discountAmount || (hasDiscount ? (originalPrice - currentPrice) : 0);
      
      return {
        totalItems: acc.totalItems + quantity,
        totalSavings: acc.totalSavings + (discountAmount * quantity),
        itemsWithDiscount: acc.itemsWithDiscount + (hasDiscount ? 1 : 0),
        hasDiscounts: acc.hasDiscounts || hasDiscount
      };
    }, {
      totalItems: 0,
      totalSavings: 0,
      itemsWithDiscount: 0,
      hasDiscounts: false
    });

    return stats;
  };

  const orderStats = calculateOrderStats();

  return `
    <div class="header">
      <h1>Comprovante de Pedido</h1>
      <p>Pedido <span class="order-number">#${order.id}</span> • ${order.eventName || 'Evento não informado'}</p>
    </div>
    
    <div class="section">
      <div class="section-title">
        <div class="section-icon">📝</div>
        Informações do Pedido
      </div>
      <div class="info-grid">
        <div class="info-item">
          <div class="info-label">Número do Pedido</div>
          <div class="info-value">#${order.id}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Evento</div>
          <div class="info-value">${order.eventName || 'Não informado'}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Data do Pedido</div>
          <div class="info-value">${formatDate(order.createdAt)}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Status</div>
          <div class="status-badge ${getStatusClass(order.status)}">
            ${getStatusIcon(order.status)} ${order.status || 'Pendente'}
          </div>
        </div>
      </div>
    </div>
    
    <div class="section">
      <div class="section-title">
        <div class="section-icon">🏢</div>
        Informações do Expositor
      </div>
      <div class="info-grid">
        <div class="info-item">
          <div class="info-label">Empresa</div>
          <div class="info-value">${order.exhibitorName || 'Não informado'}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Responsável</div>
          <div class="info-value">${order.contact || 'Não informado'}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Email</div>
          <div class="info-value">${order.email || 'Não informado'}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Telefone</div>
          <div class="info-value">${order.phone || 'Não informado'}</div>
        </div>
      </div>
    </div>
    
    <div class="section">
      <div class="section-title">
        <div class="section-icon">🛒</div>
        Itens do Pedido 
        ${orderStats.totalItems > 0 ? `(${orderStats.totalItems} ${orderStats.totalItems === 1 ? 'item' : 'itens'})` : ''}
      </div>
      
      <table class="items-table">
        <thead>
          <tr>
            <th style="width: 45%;">Item</th>
            <th class="text-center" style="width: 12%;">Qtd</th>
            <th class="text-right" style="width: 20%;">Preço Unit.</th>
            <th class="text-right" style="width: 23%;">Subtotal</th>
          </tr>
        </thead>
        <tbody>
          ${order.items && order.items.length > 0 ? order.items.map((item, index) => {
            // Verificar se tem desconto baseado nas propriedades do item
            const hasDiscount = item.hasDiscount || (item.discountAmount && item.discountAmount > 0) || (item.originalPrice && item.originalPrice > item.price);
            const originalPrice = item.originalPrice || item.price;
            const currentPrice = item.price;
            const discountAmount = item.discountAmount || (hasDiscount ? (originalPrice - currentPrice) : 0);
            
            return `
              <tr>
                <td>
                  <div>
                    <div class="item-name">${item.name || `Item ${index + 1}`}</div>
                    ${item.description ? `<div class="item-description">${item.description}</div>` : ''}
                  </div>
                </td>
                <td class="text-center">
                  <span class="quantity-badge">${item.quantity || 0}</span>
                </td>
                <td class="text-right">
                  <div class="price-container">
                    ${hasDiscount ? `
                      <div class="original-price">${formatCurrency(originalPrice)}</div>
                      <div class="discounted-price">${formatCurrency(currentPrice)}</div>
                      <div class="discount-badge">
                        💰 ${formatCurrency(discountAmount)}
                      </div>
                    ` : `
                      <div class="current-price">${formatCurrency(currentPrice)}</div>
                    `}
                  </div>
                </td>
                <td class="text-right">
                  <div class="currency" style="font-size: 17px; font-weight: 600; color: #1d1d1f;">
                    ${formatCurrency(item.total || (currentPrice * (item.quantity || 0)))}
                  </div>
                </td>
              </tr>
            `;
          }).join('') : `
            <tr>
              <td colspan="4" class="empty-state">
                <div class="empty-state-icon">📦</div>
                <div style="font-size: 17px; font-weight: 500; margin-bottom: 8px;">Nenhum item encontrado</div>
                <div style="font-size: 15px;">Este pedido não possui itens registrados</div>
              </td>
            </tr>
          `}
          
          ${orderStats.hasDiscounts && orderStats.totalSavings > 0 ? `
            <tr class="savings-row">
              <td colspan="3" class="text-right">
                <em>Economia total</em>
              </td>
              <td class="text-right">
                <em class="currency">${formatCurrency(orderStats.totalSavings)}</em>
              </td>
            </tr>
          ` : ''}
          
          <tr class="total-row">
            <td colspan="3" class="text-right">
              <strong>Valor Total do Pedido</strong>
            </td>
            <td class="text-right">
              <strong class="currency" style="font-size: 22px;">
                ${formatCurrency(order.totalValue || 0)}
              </strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    ${order.notes && order.notes.trim() ? `
      <div class="section">
        <div class="section-title">
          <div class="section-icon">💬</div>
          Observações
        </div>
        <div class="info-item">
          <div style="line-height: 1.6; color: #1d1d1f;">
            ${order.notes.replace(/\n/g, '<br>')}
          </div>
        </div>
      </div>
    ` : ''}
    
    <div class="footer">
      <div class="footer-title">Comprovante gerado em ${formatDate(new Date().toISOString())}</div>
      <div>Este documento comprova ${order.status === 'Aprovado' ? 'a aprovação' : 'o registro'} do seu pedido.</div>
      <div style="margin-top: 12px; font-size: 13px; opacity: 0.8;">
        Para dúvidas ou alterações, entre em contato através dos canais oficiais do evento.
      </div>
    </div>
  `;
};

/**
 * Função alternativa caso a principal não funcione em alguns navegadores
 * @param {Object} order - Objeto contendo os dados do pedido
 */
export const printImageBasedReceiptAlternative = (order) => {
  try {
    const receiptContent = generateReceiptHTML(order);
    
    // Usar parâmetros mais compatíveis
    const printWindow = window.open(
      '',
      'PrintReceipt',
      'width=' + window.screen.width + ',height=' + window.screen.height + ',left=0,top=0,scrollbars=1,resizable=1,menubar=0,toolbar=0,status=0'
    );
    
    if (!printWindow) {
      alert('Por favor, permita pop-ups para imprimir o comprovante.');
      return;
    }
    
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Comprovante de Pedido #${order.id}</title>
          <meta charset="utf-8">
          <style>
            body { 
              margin: 0; 
              padding: 20px; 
              font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', Arial, sans-serif;
              line-height: 1.5;
              color: #1d1d1f;
            }
            .container { 
              max-width: 800px; 
              margin: 0 auto; 
              background: white;
              border-radius: 12px;
              padding: 32px;
              box-shadow: 0 4px 24px rgba(0,0,0,0.1);
            }
            h1 { 
              color: #1d1d1f; 
              font-size: 28px; 
              font-weight: 700; 
              text-align: center;
              margin-bottom: 24px;
            }
            .print-btn {
              background: #1d1d1f;
              color: white;
              border: none;
              padding: 12px 24px;
              border-radius: 20px;
              cursor: pointer;
              font-size: 16px;
              font-weight: 600;
              margin: 8px;
            }
          </style>
        </head>
        <body>
          <div class="container">
            <h1>Comprovante de Pedido #${order.id}</h1>
            ${receiptContent}
            <div style="text-align: center; margin: 32px 0;">
              <button class="print-btn" onclick="window.print()">🖨️ Imprimir</button>
              <button class="print-btn" onclick="window.close()">✕ Fechar</button>
            </div>
          </div>
          <script>
            try {
              window.moveTo(0, 0);
              window.resizeTo(window.screen.availWidth, window.screen.availHeight);
            } catch(e) {}
            window.focus();
          </script>
        </body>
      </html>
    `);
    
    printWindow.document.close();
    printWindow.focus();
    
  } catch (error) {
    console.error('Erro na função alternativa de impressão:', error);
    throw error;
  }
};

// Exportação padrão da função principal
export default printImageBasedReceipt;